import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import { ETaskStatus, ETaskSourceType } from '@leedpulse-monorepo/enums';
import { ITaskCalendarSync } from '@leedpulse-monorepo/interfaces';

export default class Task {
  private _id: string;
  private _idContact: string;
  private _task: string;
  private _timestamp: Date;
  private _updated: Date;
  private _created: Date;
  private _notified: boolean;
  private _status: ETaskStatus;
  private _title: string;
  private _description: string | null;
  private _sourceType: ETaskSourceType | null;
  private _location: string | null;
  private _endTimestamp: Date;
  private _timezone: string | null;
  private _taxonomyKey: string | null;
  private _taskType: string | null;
  private _calendarSync: ITaskCalendarSync | null;
  private _sourceId: string | null;

  constructor(
    id: string,
    idContact: string,
    task: string,
    timestamp: Date,
    updated: Date,
    created: Date,
    notified: boolean,
    status: ETaskStatus,
    title: string,
    description: string | null,
    sourceType: ETaskSourceType | null,
    location: string | null,
    endTimestamp: Date,
    timezone: string | null,
    taxonomyKey: string | null,
    taskType: string | null,
    calendarSync: ITaskCalendarSync | null,
    sourceId: string | null
  ) {
    this._id = id;
    this._idContact = idContact;
    this._task = task;
    this._timestamp = timestamp;
    this._updated = updated;
    this._created = created;
    this._notified = notified;
    this._status = status;
    this._title = title;
    this._description = description;
    this._sourceType = sourceType;
    this._location = location;
    this._endTimestamp = endTimestamp;
    this._timezone = timezone;
    this._taxonomyKey = taxonomyKey;
    this._taskType = taskType;
    this._calendarSync = calendarSync;
    this._sourceId = sourceId;
  }

  get id(): string {
    return this._id;
  }

  get idContact(): string {
    return this._idContact;
  }

  get task(): string {
    return this._task;
  }

  get timestamp(): Date {
    return this._timestamp;
  }

  get updated(): Date {
    return this._updated;
  }

  get created(): Date {
    return this._created;
  }

  get notified(): boolean {
    return this._notified;
  }

  get status(): ETaskStatus {
    return this._status;
  }

  get title(): string {
    return this._title;
  }

  get description(): string | null {
    return this._description;
  }

  get sourceType(): ETaskSourceType | null {
    return this._sourceType;
  }

  get location(): string | null {
    return this._location;
  }

  get endTimestamp(): Date {
    return this._endTimestamp;
  }

  get timezone(): string | null {
    return this._timezone;
  }

  get taxonomyKey(): string | null {
    return this._taxonomyKey;
  }

  get taskType(): string | null {
    return this._taskType;
  }

  get calendarSync(): ITaskCalendarSync | null {
    return this._calendarSync;
  }

  get sourceId(): string | null {
    return this._sourceId;
  }

  static fromFirestore(
    data: QueryDocumentSnapshot<DocumentData, DocumentData>
  ): Task {
    const taskData = data.data();
    return new Task(
      data.id,
      taskData.id_contact,
      taskData.task,
      new Date(taskData.timestamp),
      new Date(taskData.updated),
      new Date(taskData.created),
      taskData.notified,
      taskData.status,
      taskData.title || taskData.task,
      taskData.description ?? null,
      taskData.source_type ?? null,
      taskData.location ?? null,
      new Date(taskData.endTimestamp),
      taskData.timezone ?? null,
      taskData.taxonomy_key ?? null,
      taskData.task_type ?? null,
      taskData.calendar_sync ?? null,
      taskData.source_id || taskData.id_call || null
    );
  }
}
